import React from 'react';

const CovidMessage = () => (
  <section id="one" className="tiles whatIsMomentumTiles">
    <article>
      <header className="major">
        <h3>COVID-19 Update</h3>
      </header>
      <p>
        As Ohio is reopening, we too are reevaluating the status of this year's conference.
        We remain optimistic about hosting a physical conference in October,
        but we are researching other options should this health crisis continue.
        Stay safe and stay tuned!
      </p>
    </article>
  </section>
)

export default CovidMessage;
